import React from "react";
import LocalizedWeatherGuidePage from "@/components/weather/LocalizedWeatherGuidePage";

export default function SailingDecisionGuide() {
  return <LocalizedWeatherGuidePage guideKey="sailingDecision" />;
}